import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import ExamRoutes from './exam'
/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},

  {
    path: '/password',
    name: 'password',
    component: Layout,
    meta: {title: '修改密码', icon: 'ums-role'},
    children: [{
      path: 'form',
      name: 'form',
      component: () => import('@/views/login/password'),
      meta: {title: '首页', icon: 'home'}
    }],
    hidden: true
  },

  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '数据看板', icon: 'home'}
    }]
  },
]

export const asyncRouterMap =   [
  {
    path: '/lover',
    name: 'lover',
    component: Layout,
    meta: {title: '婚恋管理', icon: 'table'},
    children: [

      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/lover/index'),
        meta: {title: '婚恋列表', icon: ''}
      },

      {
        path: 'comment',
        name: 'commentList',
        component: () => import('@/views/lover/comment'),
        meta: {title: '用户留言', icon: ''}
      },
    ]
  },
  {
    path: '/member',
    name: 'member',
    component: Layout,
    meta: {title: '会员管理', icon: 'product'},
    children: [

      {
        path: 'index',
        name: 'member_index',
        component: () => import('@/views/member/index'),
        meta: {title: '会员列表', icon: 'product'}
      },
    ]
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Layout,
    meta: {title: '投诉反馈', icon: 'order-setting'},
    children: [

      {
        path: 'index',
        name: 'feedback',
        component: () => import('@/views/feedback/index'),
        meta: {title: '投诉反馈', icon: 'product-attr'}
      },
    ]
  },
  {
    path: '/setting',
    name: 'setting',
    component: Layout,
    meta: {title: '系统配置', icon: 'order-setting'},
    children: [

      {
        path: 'banner',
        name: 'banner',
        component: () => import('@/views/banner/index'),
        meta: {title: '首页轮播', icon: ''}
      },
      {
        path: 'words',
        name: 'words',
        component: () => import('@/views/setting/words'),
        meta: {title: '敏感词', icon: ''}
      },
      {
        path: 'saying',
        name: 'saying',
        component: () => import('@/views/setting/saying'),
        meta: {title: '名言警示', icon: ''}
      },
    ]
  },
  {
    path: '/permissions',
    component: Layout,
    redirect: '/permissions/admin',
    name: 'permissions',
    hidden: true,
    meta: { title: '权限设置', icon: 'sms' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/permissions/admin.vue'),
        meta: { title: '管理员列表', icon: '' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/permissions/role.vue'),
        meta: { title: '角色管理', icon: '' }
      },

    ]
  },
  {
    path: '/recruitment',
    component: Layout,
    redirect: '/recruitment/application',
    name: 'Recruitment',
    meta: { title: '招聘管理', icon: 'table' },
    children: [
      {
        path: 'session',
        name: 'RecruitmentSession',
        component: () => import('@/views/recruitment/session'),
        meta: { title: '招聘场次' }
      },
      {
        path: 'session/create',
        name: 'RecruitmentSessionCreate',
        component: () => import('@/views/recruitment/session-edit'),
        meta: { title: '新增场次' },
        hidden: true
      },
      {
        path: 'session/edit/:id',
        name: 'RecruitmentSessionEdit',
        component: () => import('@/views/recruitment/session-edit'),
        meta: { title: '编辑场次' },
        hidden: true
      },
      {
        path: 'session/detail/:id',
        name: 'RecruitmentSessionDetail',
        component: () => import('@/views/recruitment/session-detail'),
        meta: { title: '场次详情' },
        hidden: true
      },
      {
        path: 'position',
        name: 'RecruitmentPosition',
        component: () => import('@/views/recruitment/position'),
        meta: { title: '招聘职位' }
      },
      {
        path: 'position/create',
        name: 'RecruitmentPositionCreate',
        component: () => import('@/views/recruitment/position-edit'),
        meta: { title: '新增职位' },
        hidden: true
      },
      {
        path: 'position/edit/:id',
        name: 'RecruitmentPositionEdit',
        component: () => import('@/views/recruitment/position-edit'),
        meta: { title: '编辑职位' },
        hidden: true
      },
      {
        path: 'application',
        name: 'RecruitmentApplication',
        component: () => import('@/views/recruitment/application-new'),
        meta: { title: '报名管理' }
      },
      {
        path: 'application/:id',
        name: 'RecruitmentApplicationList',
        component: () => import('@/views/recruitment/application'),
        meta: { title: '报名管理' },
        hidden: true
      },
      {
        path: 'resume/preview/:id',
        name: 'ResumePreview',
        component: () => import('@/views/recruitment/resume-preview'),
        meta: { title: '简历预览' },
        hidden: true
      },
      {
        path: 'company',
        name: 'RecruitmentCompany',
        component: () => import('@/views/recruitment/company'),
        meta: { title: '招聘单位管理' },
        // hidden: true
      },
      {
        path: 'dictionary',
        name: 'RecruitmentDictionary',
        component: () => import('@/views/recruitment/dictionary'),
        meta: { title: '字典管理' },
        // hidden: true
      },

    ]
  },
  
  {
    path: '',
    component: Layout,
    redirect: '/exam',
    name: 'Exam',
    meta: { title: '考试管理', icon: 'table' },
    children: ExamRoutes
  },
  {
    path: '',
    component: Layout,
    redirect: '/interview/interview-invitation',
    name: 'Interview',
    meta: { title: '面试管理', icon: 'table' },
    children: [
      {
        path: 'interview-invitation',
        name: 'InterviewInvitation',
        component: () => import('@/views/recruitment/interview-invitation'),
        meta: { title: '面试邀约' }
      },
      {
        path: 'interview-template',
        name: 'InterviewTemplate',
        component: () => import('@/views/recruitment/interview-template'),
        meta: { title: '邀约模板' },
        hidden: true
      },
      {
        path: 'interview-log',
        name: 'InterviewLog',
        component: () => import('@/views/recruitment/interview-log'),
        meta: { title: '邀约日志' }
      },
      {
        path: 'interview-log/:invitationId',
        name: 'InterviewLogDetail',
        component: () => import('@/views/recruitment/interview-log'),
        meta: { title: '邀约日志详情' },
        hidden: true
      },
    ]
  },
  {
    path: '/ticket',
    component: Layout,
    redirect: '/ticket/file',
    name: 'Ticket',
    meta: { title: '准考证管理', icon: 'table' },
    children: [
      {
        path: 'file',
        name: 'TicketFile',
        component: () => import('@/views/ticket/file'),
        meta: { title: '导入文件' }
      },
      {
        path: 'list',
        name: 'TicketList',
        component: () => import('@/views/ticket/list'),
        meta: { title: '准考证列表' }
      },
      {
        path: 'detail',
        name: 'TicketDetail',
        component: () => import('@/views/ticket/detail'),
        meta: { title: '准考证详情' },
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js